import { Pipe, PipeTransform } from '@angular/core';
import { SpecificGradingScale } from '@jump-tools-front/shared-interfaces';
import { getClassForScoreType } from '../../utils';

@Pipe({
  name: 'gameScoreClass',
  standalone: true,
})
export class GameScoreClassPipe implements PipeTransform {
  transform(score: number, scale: SpecificGradingScale): string {
    return getClassForScoreType(scale, score);
  }
}
